import { useState } from 'react'
import { Link } from 'react-router-dom'
import { AuthorForm } from '../components/AuthorForm'
import { useAuthors } from '../hooks/useAuthors'

export const Authors = () => {
  const { data: authors, isLoading } = useAuthors()
  const [showModal, setShowModal] = useState(false)

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem' }}>
        <h2>Autoren</h2>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>
          + Neuer Autor
        </button>
      </div>

      {isLoading ? (
        <p>Laden...</p>
      ) : authors && authors.length > 0 ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '0.875rem', marginBottom: '2rem' }}>
          {authors.map((author) => (
            <Link key={author.id} to={`/authors/${author.id}`} style={{ textDecoration: 'none' }}>
              <div className="card" style={{ display: 'flex', alignItems: 'center', gap: '0.875rem', padding: '0.875rem 1.125rem', marginBottom: 0 }}>
                <div style={{
                  width: 40, height: 40, borderRadius: '50%',
                  background: 'var(--primary)', color: 'white',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontWeight: 600, fontSize: '0.875rem', flexShrink: 0, letterSpacing: '0.02em',
                }}>
                  {author.name.split(' ').map((p: string) => p[0]).slice(0, 2).join('').toUpperCase()}
                </div>
                <span style={{ fontWeight: 500, color: 'var(--text-primary)', lineHeight: 1.35 }}>{author.name}</span>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <p>Noch keine Autoren vorhanden.</p>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <AuthorForm onSuccess={() => setShowModal(false)} onCancel={() => setShowModal(false)} />
          </div>
        </div>
      )}
    </div>
  )
}
